import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { useExpertise } from "@/hooks/usePortfolio";
import { SectionTitle } from "@/components/SectionTitle";

export const Expertise = () => {
  const { data: expertise, isLoading, error } = useExpertise();

  if (isLoading || error || !expertise) return null;

  return (
    <section id="expertise" className="section-pad relative" data-testid="expertise-section">
      <div className="container-x">
        <SectionTitle eyebrow="Capabilities" title={<>Areas of <span className="italic gold-text">expertise</span></>} subtitle="Twelve practiced disciplines refined across telecom, enterprise sales and consulting." />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...expertise].sort((a,b) => a.displayOrder - b.displayOrder).map((e, i) => {
            const rawIcon = e.iconUrl?.split(' ').pop()?.replace(/^fa-/, '') || 'sparkles';
            const iconNameCapitalized = rawIcon.split('-').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('');
            const Icon = Icons[iconNameCapitalized] || Icons[e.iconUrl] || Icons.Sparkles;
            
            return (
              <motion.div
                key={e.id}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: i * 0.04 }}
                data-testid={`expertise-card-${e.id}`}
                className="group relative rounded-2xl overflow-hidden glass p-7 grain hover:border-[hsl(var(--gold))]/50 transition-all"
              >
                <div className="absolute top-0 right-0 w-28 h-28 rounded-full bg-[hsl(var(--gold))]/8 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="font-serif text-5xl text-[hsl(var(--gold))]/30 group-hover:text-[hsl(var(--gold))]/60 transition-colors mb-3">{String(i + 1).padStart(2, "0")}</div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-lg bg-[hsl(var(--gold))]/10 border border-[hsl(var(--gold))]/30 flex items-center justify-center">
                      <Icon className="w-5 h-5 text-[hsl(var(--gold-deep))] dark:text-[hsl(var(--gold-light))]" />
                    </div>
                    <h3 className="font-serif text-lg leading-tight">{e.title}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground text-justify-luxury">{e.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
